export default "__VITE_ASSET__DHY91uj6__"